import { redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";

/**
 * Use as a route `beforeLoad` for public marketing/auth pages.
 * If the user already has a session, bounces them to the dashboard.
 * No-ops during SSR (no window) to keep prerender working.
 */
export async function redirectIfAuthenticated() {
  if (typeof window === "undefined") return;
  const { data } = await supabase.auth.getSession();
  if (data.session) {
    throw redirect({ to: "/command-center" });
  }
}
